import { composeReducers } from 'common/util/composeReducers';
import { ACTIONS } from 'workflow/actions/sentbox';
import lodash from 'lodash';
import { assignTasksByCategory, } from 'common/util/taskHelper';

export function loadMyWorkflows(state, action) {
    if (!action || action.type !== ACTIONS.LOAD_MY_WORKFLOWS) {
        return state;
    }
    let pendingTasks = [], completedTasks = [];
    let tasks = action.payload;

    const tasksWithAssignee = tasks.filter(task => !!task.binderId).map(task => {
        if(!lodash.isEmpty(task.recipients)){
            const recipientsKeyBySub = lodash.keyBy(task.recipients, 'sub');
            const tasksWithRecipientName=  task.tasks.map(item => {
                const userSub = item.assignee;
                return {
                    ...item,
                    recipient : recipientsKeyBySub[userSub]
                };
            });
            return {
                ...task,
                tasks : tasksWithRecipientName
            };
        }
    });

    pendingTasks = assignTasksByCategory(tasksWithAssignee, 'Incomplete');
    completedTasks = assignTasksByCategory(tasksWithAssignee, 'Complete');
    const myWorkflows = state.myWorkflows || [];
    return {
        ...state,
        myWorkflows : {
            ...myWorkflows,
            pending : pendingTasks,
            completed : completedTasks,
        }
    };    
}

export function loadingMyWorkflows(state, action) {
    if (!action || action.type !== ACTIONS.LOADING_MY_WORKFLOWS) {
        return state;
    }

    return {
        ...state,
        loadingSentboxTasks: action.payload
    };
}

export function loadingPendingEvents(state, action) {
    if (!action || action.type !== ACTIONS.LOADING_PENDING_EVENTS) {
        return state;
    }

    return {
        ...state,
        loadingPendingEvents: action.payload
    };
}

export function loadingCompletedEvents(state, action) {
    if (!action || action.type !== ACTIONS.LOADING_COMPLETED_EVENTS) {
        return state;
    }

    return {
        ...state,
        loadingCompletedEvents: action.payload
    };
}

export function loadingPendingDOA(state, action) {
    if (!action || action.type !== ACTIONS.LOADING_PENDING_DOA) {
        return state;
    }

    return {
        ...state,
        loadingPendingDOA: action.payload
    };
}

export function loadingCompletedDOA(state, action) {
    if (!action || action.type !== ACTIONS.LOADING_COMPLETED_DOA) {
        return state;
    }

    return {
        ...state,
        loadingCompletedDOA: action.payload
    };
}

export function loadPendingEventTasksCreatedByUser(state, action) {
    if (!action || action.type !==ACTIONS.PENDING_EVENT_SIGNATURES_CREATED_BY_USER){
        return state;
    }

    return {
        ...state,
        sentBox : {
            ...state.sentBox,
            pendingEvents : action.payload
        }
    };
}

export function loadCompletedEventTasksCreatedByUser(state, action) {
    if (!action || action.type !== ACTIONS.COMPLETED_EVENT_SIGNATURES_CREATED_BY_USER){
        return state;
    }
    
    return {
        ...state,
        sentBox : {
            ...state.sentBox,
            completedEvents : action.payload
        }
    };
}


export function loadPendingDOATasksCreatedByUser(state, action) {
    if (!action || action.type !==ACTIONS.PENDING_DOA_SIGNATURES_CREATED_BY_USER){
        return state;
    }

    return {
        ...state,
        sentBox : {
            ...state.sentBox,
            pendingDOAs: action.payload
        }
    };
}

export function loadCompletedDOATasksCreatedByUser(state, action) {
    if (!action || action.type !== ACTIONS.COMPLETED_DOA_SIGNATURES_CREATED_BY_USER){
        return state;
    }
    
    return {
        ...state,
        sentBox : {
            ...state.sentBox,
            completedDOAs: action.payload
        }
    };
}

export function unloadSentbox(state, action) {
    if (!action || action.type !== ACTIONS.UNLOAD_SENTBOX){
        return state;
    }

    return {
        ...state,
        sentBox : {
            pendingEvents : [],
            completedEvents : [],
        },
        myWorkflows : [],
    };
}

export default composeReducers(
    loadMyWorkflows,
    loadPendingEventTasksCreatedByUser,
    loadCompletedEventTasksCreatedByUser,
    loadPendingDOATasksCreatedByUser,
    loadCompletedDOATasksCreatedByUser,
    loadingMyWorkflows,
    loadingPendingEvents,
    loadingCompletedEvents,
    loadingPendingDOA,
    loadingCompletedDOA,
    unloadSentbox,
);
